import { render } from "./DownloadMenu.vue?vue&type=template&id=11140cf4&scoped=true&ts=true"
import script from "./DownloadMenu.vue?vue&type=script&lang=ts"
export * from "./DownloadMenu.vue?vue&type=script&lang=ts"

import "./DownloadMenu.vue?vue&type=style&index=0&id=11140cf4&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11140cf4"]])

export default __exports__